import { render } from "./GuestRow.vue?vue&type=template&id=0bbba6bd&scoped=true"
import script from "./GuestRow.vue?vue&type=script&lang=js"
export * from "./GuestRow.vue?vue&type=script&lang=js"

import "./GuestRow.vue?vue&type=style&index=0&id=0bbba6bd&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0bbba6bd"

export default script